exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-list-your-shop-tsx": () => import("./../../../src/pages/list-your-shop.tsx" /* webpackChunkName: "component---src-pages-list-your-shop-tsx" */),
  "component---src-pages-map-tsx": () => import("./../../../src/pages/map.tsx" /* webpackChunkName: "component---src-pages-map-tsx" */),
  "component---src-pages-online-only-tsx": () => import("./../../../src/pages/online-only.tsx" /* webpackChunkName: "component---src-pages-online-only-tsx" */)
}

